import * as Sentry from '@sentry/react';

/**
 * Browser error reporting, started before React mounts.
 *
 * Its own Sentry project and DSN (`SENTRY_DSN_REVIEW_UI`), on purpose: this one ships to every
 * browser that loads the app, so it is public by construction, and pointing it at a backend project
 * would mean anyone could post events into the stream the on-call rotation watches.
 *
 * All three values are compiled in by `define` in vite.config.ts, already trimmed.
 *
 * Errors only, matching the services — no tracing, and no session replay, which would record what
 * people type into a console that holds meeting notes and client material.
 */
export function initBrowserSentry(): void {
  const dsn = import.meta.env.SENTRY_DSN_REVIEW_UI;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.SENTRY_ENVIRONMENT || import.meta.env.MODE,
    // Groups events by deploy for the regression view. Source maps do not depend on it — the upload
    // matches them by the debug ID it stamps into each file.
    release: import.meta.env.SENTRY_RELEASE || undefined,
    sendDefaultPii: false,
    tracesSampleRate: 0,
    initialScope: { tags: { service: 'review-ui' } },
  });
}
